import { SvgIcon, SvgIconProps } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';

export const IllustrationCloseCircle = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      style={{ fill: 'none', ...props.style }}
      data-testid="IllustrationCloseCircle"
      {...props}>
      <path
        d="M49.8515 87.2783C73.5996 87.2783 92.8514 68.0265 92.8514 44.2783C92.8514 20.5302 73.5996 1.27832 49.8515 1.27832C26.1034 1.27832 6.85156 20.5302 6.85156 44.2783C6.85156 68.0265 26.1034 87.2783 49.8515 87.2783Z"
        fill={theme.palette.error['190p']}
        stroke={theme.palette.primary.main}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M44.1464 87.2783C67.8945 87.2783 87.1463 68.0265 87.1463 44.2783C87.1463 20.5302 67.8945 1.27832 44.1464 1.27832C20.3983 1.27832 1.14648 20.5302 1.14648 44.2783C1.14648 68.0265 20.3983 87.2783 44.1464 87.2783Z"
        fill={theme.palette.error['190p']}
        stroke={theme.palette.primary.main}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M28.4863 27.665L62.8768 62.0556"
        stroke={theme.palette.error.main}
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M62.8768 27.665L28.4863 62.0556"
        stroke={theme.palette.error.main}
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M46.9986 136.722C68.9318 136.722 86.7121 132.593 86.7121 127.5C86.7121 122.407 68.9318 118.278 46.9986 118.278C25.0655 118.278 7.28516 122.407 7.28516 127.5C7.28516 132.593 25.0655 136.722 46.9986 136.722Z"
        fill={theme.palette.primary.main}
      />
    </SvgIcon>
  );
};
